// extracted by mini-css-extract-plugin
export default {"spinner":"SmallLoadingIndicator_spinner__mm3lJ","spin":"SmallLoadingIndicator_spin__Jk9Hc"};